import React from 'react';
import { Badge, BadgePriority } from 'wix-ui-tpa/cssVars';
import { IntakeFormStatus } from '../../../../../utils/state/types';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { classes } from './IntakeFormStatusBadge.st.css';
import { IntakeFormSectionDataHook } from '../dataHooks';

const RequiredBadge = () => {
  const { t } = useTranslation();

  return (
    <Badge
      priority={BadgePriority.primary}
      className={classes.requiredBadge}
      data-hook={IntakeFormSectionDataHook.REQUIRED_BADGE}
    >
      {t('app.intake-form-section.badge.required')}
    </Badge>
  );
};

const CompletedBadge = () => {
  const { t } = useTranslation();

  return (
    <Badge
      priority={BadgePriority.default}
      data-hook={IntakeFormSectionDataHook.REQUIRED_BADGE}
    >
      {t('app.intake-form-section.badge.completed')}
    </Badge>
  );
};

export const IntakeFormStatusBadge = ({
  status,
}: {
  status: IntakeFormStatus;
}) => {
  if (status === IntakeFormStatus.COMPLETED) {
    return <CompletedBadge />;
  }
  if (status === IntakeFormStatus.REQUIRED) {
    return <RequiredBadge />;
  }
  return null;
};
